import { computed, getCurrentInstance, watch } from '@nuxtjs/composition-api';
import { LayoutProps } from './internals/useLayoutPropsProvider';
import { useStore } from './useStore';

export const useLayoutProps = (layoutPropsWatcher: () => LayoutProps) => {
  const vm = getCurrentInstance();
  const store = useStore();

  const layoutProps = computed(layoutPropsWatcher);

  const updateLayoutProps = () => {
    if (vm?.uid) {
      store.commit('internals/layoutProps/setLayoutProps', { uid: vm.uid, layoutProps });
    }
  };

  watch(
    layoutProps,
    () => {
      updateLayoutProps();
    },
    { immediate: true, deep: true }
  );

  return layoutProps;
};
